import _ from 'lodash';
import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import { navigateAction } from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import InventoryRecordStore, { defaultSorter } from '../../stores/InventoryRecordStore';
import WineSkuStore from '../../stores/WineSkuStore';
import Store from '../../models/Store';
import NavSearchPng from '../Navbar/images/nav_search.png';
import NavSearchSvg from '../Navbar/images/nav_search.svg';
import styles from './index.sass';

const SearchRouteNames = ['universalSearch', 'search', 'category', 'sparkling'];

class InventorySearch extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    filters: React.PropTypes.array,
    additionalFilters: React.PropTypes.array,
    currentRoute: React.PropTypes.object,
    searchInputOpen: React.PropTypes.bool, // for mobile display of input
    onOpenSearchInput: React.PropTypes.func,
    store: React.PropTypes.instanceOf(Store)
  };

  static defaultProps = {
    className: '',
    additionalFilters: []
  };

  static contextTypes = {
    delectoryApi: React.PropTypes.object,
    executeAction: React.PropTypes.func,
    getUserAgent: React.PropTypes.func,
    trackEvent: React.PropTypes.func,
    buildURLForRoute: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      searchQuery: this.extractSearchQueryFromFilters(props.currentRoute, props.filters)
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.filters !== this.props.filters || nextProps.currentRoute !== this.props.currentRoute) {
      this.setState({searchQuery: this.extractSearchQueryFromFilters(nextProps.currentRoute, nextProps.filters)});
    }
  }

  extractSearchQueryFromFilters(currentRoute, filters) {
    if(!currentRoute || -1 === SearchRouteNames.indexOf(currentRoute.name)) {
      return '';
    }
    return _.reduce(filters, (arr, filter) => {
      if(filter.type !== 'text') {return arr;}
      arr.push(filter.value.replace(/-/g, ' '));
      return arr;
    }, []).join(' ');
  }

  executeSearch(filters, uiMethod) {
    if(this.props.store) {
      trackSearchEvent(this.context, {
        filters: filters,
        pagination: this.props.pagination,
        sorter: this.props.sorter,
        uiMethod: uiMethod
      });
    }
    this.context.executeAction(navigateAction, {
      url: this.context.buildURLForRoute(this.props.store ? 'search' : 'universalSearch', {
        filters: filters,
        // TODO: pagination?
        // pagination: this.props.pagination,
        sorter: (!this.props.sorter || _.isEqual(this.props.sorter, defaultSorter)) ? null : this.props.sorter
      })
    });
  }

  submit(value) {
    let filters = value ? [{ type: 'text', value: value }] : [];
    filters = filters.concat(this.props.additionalFilters);
    this.executeSearch(filters, 'search_button');
  }

  handleOnChangeSearchInput(e) {
    let q = e.target.value;
    this.setState({searchQuery: q});
  }

  handleOnKeyDownSearchInput(e) {
    if(e.which === 13) {
      this.submit(e.target.value);
    }
  }

  handleOnClickSearchButton() {
    if(this.state.searchQuery) {
      return this.submit(this.state.searchQuery);
    }
  }

  handleOnClickMobileSearchButton() {
    this.props.onOpenSearchInput(true);
    let routeName = this.props.store ? 'search' : 'universalSearch';
    if(this.props.currentRoute.name !== routeName) {
      this.context.executeAction(navigateAction, {url: this.context.buildURLForRoute(routeName, {})});
    }
  }

  render() {
    this.isMobile = this.isMobile || this.context.getUserAgent().isMobile;

    if(this.isMobile && !this.props.searchInputOpen) {
      let mobileSearchButtonProps = {
        className: styles.mobileExpandButton,
        onClick: this.handleOnClickMobileSearchButton.bind(this)
      };
      return (
        <div className={styles.inventorySearch}>
          <button {...mobileSearchButtonProps}>
            <img src={NavSearchPng} srcSet={NavSearchSvg} />
          </button>
        </div>
      );
    }

    let searchInputProps = {
      ref: 'search_input',
      className: styles.searchInput,
      type: 'text',
      value: this.state.searchQuery,
      onChange: this.handleOnChangeSearchInput.bind(this),
      onKeyDown: this.handleOnKeyDownSearchInput.bind(this)
    };

    let classNames = `${this.props.className} ${styles.inventorySearch} ${styles.expanded}`;
    if(!this.props.store) {
      classNames += ` ${styles.universal}`;
    }
    let searchButton;
    let placeholder;
    if(!this.state.searchQuery) {
      let placeholderText = this.props.store ? 'Search our store' : 'Search';
      placeholder = <span className={styles.placeholder}><img src={NavSearchPng} srcSet={NavSearchSvg} /><span> {placeholderText}</span></span>;
    } else {
      let searchButtonProps = {
        className: styles.searchButton,
        onClick: this.handleOnClickSearchButton.bind(this)
      };
      searchButton = <button {...searchButtonProps} />;
    }

    return (
      <div className={classNames}>
        <input {...searchInputProps} />
        {searchButton}
        {placeholder}
      </div>
    );
  }
}

InventorySearch = connectToStores(InventorySearch, [InventoryRecordStore, WineSkuStore], (context, props) => {
  if(props.store) {
    return context.getStore(InventoryRecordStore).getCurrentSearchState();
  }
  return context.getStore(WineSkuStore).getCurrentSearchState();
});

export default InventorySearch;

export function trackSearchEvent(context, values) {
  let { filters, pagination, sorter, uiMethod } = values;
  if(!sorter) {
    sorter = defaultSorter;
  }
  let priceFilterMin, priceFilterMax, valueArray = [];
  _.each(filters, (f) => {
    switch(f.type) {
      case 'min_price_in_cents':
        priceFilterMin = parseInt(f.value / 100);
        break;
      case 'max_price_in_cents':
        priceFilterMax = parseInt(f.value / 100);
        break;
      case 'store_id':
        break;
      default:
        valueArray.push(`${f.type}:${f.value}`);
        break;
    }
  });
  context.trackEvent('search', {
    value: valueArray.join(' '),
    ui_method: uiMethod,
    price_filter_min: priceFilterMin,
    price_filter_max: priceFilterMax,
    sort_setting: `${sorter.key}:${sorter.direction}`,
    result_count: pagination.totalResults
  });
}



// WEBPACK FOOTER //
// banquet/components/InventorySearch/index.js